import BaseRequest from '@common/services/_baseRequest';


export default {

  list: (vars = {}, id_corso = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      { id_progetto: id_corso, ...vars },
      {},
      null,
      'get',
      'affidamento/prova',
      cb,
      ecb || null,
      null
    );
  },

  detail: (params = {}, id = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      params,
      {},
      null,
      'get',
      'affidamento/prova/' + id,
      cb,
      ecb || null,
      null
    );
  },

  create: (data = {}, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      data,
      null,
      'post',
      'affidamento/prova',
      cb,
      ecb || null,
      null
    );
  },

  update: (params = {}, id = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      params,
      null,
      "put",
      'affidamento/prova/' + id,
      cb,
      ecb || null,
      null
    );
  },

  delete: (id, cb, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'delete',
      'affidamento/prova/' + id,
      cb,
      ecb || null,
      null
    );
  },

}
